;(function(){
    document.addEventListener('DOMContentLoaded', function(){
	    /* If we have a program slug, go get the program showcase image from the Media API */
	    var el = $("#programTitle");
	    if(el.data('programSlug')){
		    var a = $.ajax({
				 url:"https://mediaapi.whro.org/shows/"+el.data('programSlug')
				,dataType:"json"
			});
			a.done(function(response){
				var imgs = JSON.parse(response.results.images);
				if(imgs && imgs.length){
					img = $.grep(imgs,function(i){
						return i.profile == "show-showcase";	
					})[0]
				}
				if(img && img.image){ 
					el.hide().after("<img class='mb5' src='"+img.image+"' style='width:100%' alt='"+el.html()+"' />")
				}				
			})
	    }
	}, false)
})();